<template>
  <div class="docs-container">
    <div class="docs-box-scroll">
      <div class="docs-list" v-if = !showDataBlockChain>
        <DocumentDetail 
          v-for="(document, index) in documents" :key="index"
          v-bind:id="document.id"
          v-bind:blockchain="document.blockchain"
          v-bind:binary="document.binary"
          v-bind:contentType="document.contentType"
          v-bind:documentType="document.documentType"
          v-bind:fileName="document.fileName"
        ></DocumentDetail>
      </div>
      <div class="data-block-chain" v-else>
         <DataBlockChain 
        ></DataBlockChain>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DocumentDetail from '@/components/containerViews/containerDocsComponets/DocumentDetail'
import DataBlockChain from '@/components/containerViews/containerDocsComponets/DataBlockChain'
import {getData} from '@/services/api'

export default {
  name: 'ContainerDocs',
  components: {
    DocumentDetail,
    DataBlockChain
  },
  data(){
    return {
        showDataBlockChain: false,
     }
  },
  computed: {
    ...mapGetters(["view_role"]),  
    ...mapGetters("user",{
      isLoggedIn: 'isLoggedIn',
      user: 'user'
    }),
    ...mapGetters("container",{
      container_id: 'container_id',
      documents: 'availableDocuments'
    }),
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang= "scss" scoped>

.docs-container {
  position: absolute;
  width:100%;
  bottom: 30px;
  top:151px;
  display: flex;
  flex-direction: column;
}
.docs-box-scroll {
  overflow: auto;
  /* margin: 12px; */
  flex: 1;
  /* border-top: 1px solid lightgray; 
  padding-top: 10px;  */
}

.data-block-chain {
  padding-top: 0.5rem;
  padding-bottom: 1rem;
  margin: 1.2rem;
}


</style>
